import React from "react";

class Hi extends React.Component {
  render() {
    let { color = "#F5812E" } = this.props;
    return (
      /* in <svg></svg> is the content of svg file( only color is editable prop so far ) */
      <svg
        width="250px"
        height="250px"
        viewBox="0 0 300 299"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink"
      >
        <title>Group 6</title>
        <desc>Created with Sketch.</desc>
        <g
          id="Guideline"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="Illustrations" transform="translate(-789.000000, -220.000000)">
            <g id="Group-6" transform="translate(789.000000, 220.000000)">
              <ellipse
                id="Oval-Copy-3"
                fill={color}
                cx="150"
                cy="149.5"
                rx="150"
                ry="149.5"
              />
              <path
                d="M148.041941,298.987523 C146.887934,298.972809 145.737068,298.945107 144.589484,298.904556 C143.764173,298.338481 143.223287,297.391786 143.223287,296.319684 L143.223287,273.596824 C143.223287,272.175605 144.184016,270.931686 145.565141,270.565163 C162.805854,265.988019 174.847147,250.401061 174.847147,232.660467 L174.847147,231.091133 C174.847147,229.360818 173.431304,227.953407 171.69101,227.953407 C169.950716,227.953407 168.534873,229.360818 168.534873,231.091133 L168.534873,232.660467 C168.534873,250.828776 153.668522,265.609885 135.395437,265.609885 L120.205898,265.609885 C101.932813,265.609885 87.0664614,250.828776 87.0664614,232.660467 L87.0664614,231.091133 C87.0664614,229.360818 85.6506185,227.953407 83.9103247,227.953407 C82.1700309,227.953407 80.7541879,229.360818 80.7541879,231.091133 L80.7541879,232.660467 C80.7541879,250.079412 92.5227907,265.590743 109.373405,270.382216 C110.728019,270.766939 111.661604,271.998306 111.661604,273.399127 L111.661604,294.072433 C109.538731,293.514718 107.434274,292.911787 105.349331,292.264738 L105.349331,275.698683 C100.05933,273.882385 95.1165039,271.082312 90.8162675,267.498985 L90.8162675,286.912861 C88.6862617,286.000368 86.5817149,285.040119 84.5039838,284.033466 L84.503994,261.086087 C84.2890611,260.819981 84.0716033,260.556385 83.862667,260.285259 C83.0777358,259.266651 82.3407779,258.222625 81.6508464,257.156006 L60.5173545,257.156006 L60.5173545,269.496526 C58.3682398,267.901974 56.2634238,266.251425 54.205081,264.547047 L54.205081,257.156006 L53.6287704,257.156006 C51.885636,257.156006 50.4726336,255.750791 50.4726336,254.017966 L50.4726336,221.577224 C42.0236555,218.676734 34.4599737,213.266754 28.9859701,206.1638 C22.8229818,198.166506 19.5652174,188.613685 19.5652174,178.538695 L19.5652174,176.969675 C19.5652174,171.77873 23.8127463,167.555556 29.0336277,167.555556 C34.2545092,167.555556 38.502038,171.77873 38.502038,176.969675 L38.502038,178.538695 C38.502038,191.348173 47.6317949,202.073993 59.7605129,204.63024 C58.18781,202.249723 57.2693742,199.405404 57.2693742,196.350522 L57.2693742,194.17084 C57.2693742,185.82993 64.0942043,179.043919 72.4832159,179.043919 C80.8722274,179.043919 87.6973732,185.82993 87.6973732,194.17084 L87.6973732,196.350522 C87.6973732,199.48511 86.7331734,202.399722 85.0844076,204.817581 C97.708639,202.655472 107.345903,191.698378 107.345903,178.538695 L107.345903,176.969675 C107.345903,171.77873 111.593432,167.555556 116.814313,167.555556 C122.035194,167.555556 126.282723,171.77873 126.282723,176.969675 L126.282723,178.538695 C126.282723,184.133506 125.268025,189.601226 123.266403,194.789661 C122.64212,196.407635 120.815979,197.216935 119.189306,196.595917 C117.561686,195.975213 116.74835,194.160171 117.372634,192.542197 C119.096516,188.073943 119.97045,183.362176 119.97045,178.538695 L119.97045,176.969675 C119.97045,175.23936 118.554607,173.831635 116.814313,173.831635 C115.074019,173.831635 113.658176,175.23936 113.658176,176.969675 L113.658176,178.538695 C113.658176,196.707004 98.7918252,211.488113 80.5187401,211.488113 L65.3292006,211.488113 C47.0561155,211.488113 32.1897645,196.707004 32.1897645,178.538695 L32.1897645,176.969675 C32.1897645,175.23936 30.7739215,173.831635 29.0336277,173.831635 C27.2933339,173.831635 25.8774909,175.23936 25.8774909,176.969675 L25.8774909,178.538695 C25.8774909,195.95764 37.6460937,211.469284 54.4963924,216.260757 C55.8510063,216.645481 56.7845915,217.876848 56.7845915,219.277669 L56.7845915,250.88024 L57.3609021,250.88024 L78.259893,250.88024 C75.7450832,245.189405 74.4415987,239.029746 74.4415987,232.660467 L74.4415987,231.091133 C74.4415987,225.900502 78.6891276,221.677328 83.9100091,221.677328 C89.1308905,221.677328 93.3784194,225.900502 93.3784194,231.091133 L93.3784194,232.660467 C93.3784194,245.469945 102.508492,256.195765 114.63721,258.752013 C113.064507,256.371182 112.146071,253.526863 112.146071,250.471667 L112.146071,248.291985 C112.146071,239.951075 118.970901,233.165378 127.359913,233.165378 C135.748924,233.165378 142.57407,239.951075 142.57407,248.291985 L142.57407,250.471667 C142.57407,253.606569 141.609555,256.521494 139.960789,258.939354 C152.585336,256.777558 162.2226,245.820464 162.2226,232.660467 L162.2226,231.091133 C162.2226,225.900502 166.470129,221.677328 171.69101,221.677328 C176.911891,221.677328 181.15942,225.900502 181.15942,231.091133 L181.15942,232.660467 C181.15942,252.426666 168.274808,269.887347 149.535561,275.940312 L149.535561,296.319684 C149.535561,297.44603 148.938557,298.433958 148.041941,298.987523 Z M76.0869266,279.620189 C73.8774436,278.37079 71.7029164,277.067102 69.5651705,275.710947 L69.5652174,271.084541 C69.5652174,269.35058 71.0251087,267.944444 72.826087,267.944444 C74.6270652,267.944444 76.0869565,269.35058 76.0869565,271.084541 L76.0869565,279.620206 Z M117.479951,199.924947 C118.934397,200.949593 119.276696,202.950795 118.244633,204.394789 L118.181986,204.482314 C117.552286,205.36333 116.556714,205.833333 115.545642,205.833333 C114.89915,205.833333 114.246845,205.640972 113.679469,205.241501 C112.225023,204.216855 111.882725,202.215653 112.914787,200.771659 L112.977434,200.684134 C114.009496,199.239819 116.025183,198.900621 117.479951,199.924947 Z M110.148524,209.147624 C111.261734,210.486811 111.06407,212.463751 109.706799,213.56233 C104.586604,217.708195 98.7653687,220.66043 92.4042124,222.337159 C92.1296439,222.409937 91.8538041,222.444444 91.5824135,222.444444 C90.1781096,222.444444 88.8936118,221.518714 88.5141733,220.115846 C88.0613258,218.441941 89.0690306,216.722862 90.7647457,216.275839 C96.2443589,214.831562 101.261273,212.286824 105.676298,208.711894 C107.033251,207.613002 109.035631,207.80781 110.148524,209.147624 Z M63.5816477,194.170526 L63.5816477,196.350209 C63.5816477,201.230488 67.5747919,205.200736 72.4832159,205.200736 C77.3919554,205.200736 81.3850996,201.230488 81.3850996,196.350209 L81.3850996,194.170526 C81.3850996,189.289933 77.3916398,185.319685 72.4832159,185.319685 C67.5747919,185.319685 63.5816477,189.289933 63.5816477,194.170526 Z M136.261797,250.471667 L136.261797,248.291985 C136.261797,243.411705 132.268337,239.441457 127.359913,239.441457 C122.451489,239.441457 118.458345,243.411705 118.458345,248.291985 L118.458345,250.471667 C118.458345,255.351947 122.451489,259.322194 127.359913,259.322194 C132.268652,259.322194 136.261797,255.351947 136.261797,250.471667 Z M166.304348,176.222222 C168.105326,176.222222 169.565217,177.618385 169.565217,179.340049 L169.565217,183.215507 C169.565217,184.937171 168.105326,186.333333 166.304348,186.333333 C164.50337,186.333333 163.043478,184.937171 163.043478,183.215507 L163.043478,179.340049 C163.043478,177.618385 164.50337,176.222222 166.304348,176.222222 Z M166.304348,195 C168.105326,195 169.565217,196.396163 169.565217,198.117826 L169.565217,201.993285 C169.565217,203.714948 168.105326,205.111111 166.304348,205.111111 C164.50337,205.111111 163.043478,203.714948 163.043478,201.993285 L163.043478,198.117826 C163.043478,196.396163 164.50337,195 166.304348,195 Z M178.031166,187.055556 C179.758901,187.055556 181.15942,188.510906 181.15942,190.305556 C181.15942,192.100206 179.758901,193.555556 178.031166,193.555556 L174.142747,193.555556 C172.415012,193.555556 171.014493,192.100206 171.014493,190.305556 C171.014493,188.510906 172.415012,187.055556 174.142747,187.055556 L178.031166,187.055556 Z M159.190587,187.055556 C160.918321,187.055556 162.318841,188.510906 162.318841,190.305556 C162.318841,192.100206 160.918321,193.555556 159.190587,193.555556 L155.302167,193.555556 C153.574432,193.555556 152.173913,192.100206 152.173913,190.305556 C152.173913,188.510906 153.574432,187.055556 155.302167,187.055556 L159.190587,187.055556 Z M88.7681159,150.222222 C90.5690942,150.222222 92.0289855,151.618385 92.0289855,153.340049 L92.0289855,157.215507 C92.0289855,158.937171 90.5690942,160.333333 88.7681159,160.333333 C86.9671377,160.333333 85.5072464,158.937171 85.5072464,157.215507 L85.5072464,153.340049 C85.5072464,151.618385 86.9671377,150.222222 88.7681159,150.222222 Z M88.7681159,169 C90.5690942,169 92.0289855,170.396163 92.0289855,172.117826 L92.0289855,175.993285 C92.0289855,177.714948 90.5690942,179.111111 88.7681159,179.111111 C86.9671377,179.111111 85.5072464,177.714948 85.5072464,175.993285 L85.5072464,172.117826 C85.5072464,170.396163 86.9671377,169 88.7681159,169 Z M100.494934,161.777778 C102.222669,161.777778 103.623188,163.233128 103.623188,165.027778 C103.623188,166.822428 102.222669,168.277778 100.494934,168.277778 L96.6065148,168.277778 C94.8787802,168.277778 93.4782609,166.822428 93.4782609,165.027778 C93.4782609,163.233128 94.8787802,161.777778 96.6065148,161.777778 L100.494934,161.777778 Z M81.6543548,161.777778 C83.3820894,161.777778 84.7826087,163.233128 84.7826087,165.027778 C84.7826087,166.822428 83.3820894,168.277778 81.6543548,168.277778 L77.7659351,168.277778 C76.0382004,168.277778 74.6376812,166.822428 74.6376812,165.027778 C74.6376812,163.233128 76.0382004,161.777778 77.7659351,161.777778 L81.6543548,161.777778 Z"
                id="Combined-Shape"
                fill="#FFFFFF"
              />
              <g id="Group-5" transform="translate(150.000000, 70.055556)">
                <path
                  d="M0.42825326,26.2518952 L32.9710145,26.2518952 L0.42825326,26.2518952 L0.42825326,0.0320952209 L0.42825326,26.2518952 Z M0.42825326,26.2518952 L0.42825326,74.3888889 L0.42825326,26.2518952 L0.362318841,26.2518952 L0.42825326,26.2518952 Z M36.5942029,-2.84217094e-14 L36.5942029,74.3567937 L36.5942029,-2.84217094e-14 Z"
                  id="Combined-Shape"
                  stroke="#FFFFFF"
                  stroke-width="12"
                  stroke-linecap="square"
                />
                <path
                  d="M59.057971,42.9444444 L59,67.5254093"
                  id="Path-3-Copy-2"
                  stroke="#FFFFFF"
                  stroke-width="12"
                  stroke-linecap="square"
                />
                <path
                  d="M87.3188406,3.19262689 L87.3188406,45.955607"
                  id="Path-3-Copy-5"
                  stroke="#FFFFFF"
                  stroke-width="12"
                  stroke-linecap="square"
                />
                <path
                  d="M59.057971,20.3175215 L59.057971,23.9480796"
                  id="Path-3-Copy-3"
                  stroke="#FFFFFF"
                  stroke-width="12"
                  stroke-linecap="square"
                />
                <ellipse
                  id="Oval"
                  fill="#FFFFFF"
                  cx="87.6811594"
                  cy="68.6111111"
                  rx="6.52173913"
                  ry="6.5"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

class Lock extends React.Component {
  render() {
    let { color = "#F5812E" } = this.props;
    return (
      <svg
        width="250px"
        height="250px"
        viewBox="0 0 300 300"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink"
      >
        <title>Group 4</title>
        <desc>Created with Sketch.</desc>
        <g
          id="Guideline"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="Illustrations" transform="translate(-21.000000, -220.000000)">
            <g id="Group-4" transform="translate(21.000000, 220.000000)">
              <circle id="Oval" fill={color} cx="150" cy="150" r="150" />
              <g id="Group-3" transform="translate(82.608696, 53.623188)">
                <g id="wanted" fill="#FFFFFF" fill-rule="nonzero">
                  <path
                    d="M132.729769,0 L2.77747781,0 C1.24394482,0 0,1.23896944 0,2.76636879 L0,183.465515 C0,184.992915 1.24394482,186.231884 2.77747781,186.231884 L91.3486316,186.231884 C92.8835911,186.231884 94.1261094,184.992915 94.1261094,183.465515 C94.1261094,181.938116 92.8835911,180.700568 91.3486316,180.700568 L5.5535288,180.700568 L5.5535288,5.53131647 L129.953717,5.53131647 L129.953717,180.700568 L100.606891,180.700568 C99.0719311,180.700568 97.8294127,181.938116 97.8294127,183.465515 C97.8294127,184.992915 99.0719311,186.231884 100.606891,186.231884 L132.731195,186.231884 C134.264728,186.231884 135.507246,184.992915 135.507246,183.465515 L135.507246,2.76636879 C135.507246,1.23896944 134.264728,0 132.729769,0 Z"
                    id="Path"
                  />
                  <path
                    d="M13.6409226,34.9833629 C12.1107689,34.9833629 10.8695652,36.2231433 10.8695652,37.7547199 L10.8695652,121.141686 C10.8695652,122.67184 12.1107689,123.913043 13.6409226,123.913043 L121.141686,123.913043 C122.673263,123.913043 123.913043,122.67184 123.913043,121.141686 L123.913043,13.6409226 C123.913043,12.1107689 122.673263,10.8695652 121.141686,10.8695652 L13.6409226,10.8695652 C12.1107689,10.8695652 10.8695652,12.1107689 10.8695652,13.6409226 L10.8695652,28.5182858 C10.8695652,30.0484395 12.1107689,31.2882199 13.6409226,31.2882199 C15.1710763,31.2882199 16.4122799,30.0484395 16.4122799,28.5182858 L16.4122799,16.4122799 L118.371752,16.4122799 L118.371752,118.371752 L16.4122799,118.371752 L16.4122799,37.7547199 C16.4122799,36.2231433 15.1710763,34.9833629 13.6409226,34.9833629 L13.6409226,34.9833629 Z"
                    id="Path"
                  />
                </g>
                <rect
                  id="Rectangle"
                  stroke="#FFFFFF"
                  stroke-width="7"
                  x="41.9057971"
                  y="67.9927536"
                  width="51.6956522"
                  height="37.9275362"
                  rx="7"
                />
                <path
                  d="M55.4347826,67.3913043 C55.4347826,58.5725472 55.4347826,49.5548014 55.4347826,40.338067 C57.8575676,33.9622565 61.7753623,34.972996 67.7536232,34.972996 C73.7318841,34.972996 77.1404645,34.1661095 79.3478261,40.338067 C79.3478261,47.5479314 79.3478261,56.5656771 79.3478261,67.3913043"
                  id="Path-2"
                  stroke="#FFFFFF"
                  stroke-width="7"
                />
                <path
                  d="M65.2173913,92.2713686 C62.6705653,91.2615297 60.8695652,88.7758705 60.8695652,85.8695652 C60.8695652,82.067605 63.951663,78.9855072 67.7536232,78.9855072 C71.5555834,78.9855072 74.6376812,82.067605 74.6376812,85.8695652 C74.6376812,88.7758705 72.8366811,91.2615297 70.2898551,92.2713686 L70.2898551,95.2898551 C70.2898551,96.6905773 69.1543454,97.826087 67.7536232,97.826087 C66.352901,97.826087 65.2173913,96.6905773 65.2173913,95.2898551 L65.2173913,92.2713686 Z"
                  id="Combined-Shape"
                  fill="#FFFFFF"
                />
                <g
                  id="Group-2"
                  transform="translate(21.739130, 139.130435)"
                  stroke="#FFFFFF"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="5"
                >
                  <polyline
                    id="Path-4"
                    points="0 0 0 28.9855072 14.4927536 28.9855072"
                  />
                  <path
                    d="M31.884058,0 C29.468599,0 27.0531401,1.97550318 24.6376812,5.92650955 L24.6376812,23.0589977 C27.0531401,27.0100041 29.468599,28.9855072 31.884058,28.9855072 C34.2995169,28.9855072 36.7149758,27.0100041 39.1304348,23.0589977 L39.1304348,5.92650955 C36.7149758,1.97550318 34.2995169,0 31.884058,0 Z"
                    id="Path-8"
                  />
                  <path
                    d="M68.8405797,7.49130853 C68.8405797,3.31920788 65.2173913,-1.42108547e-14 61.5942029,-1.42108547e-14 C57.9710145,-1.42108547e-14 54.3478261,0.489863437 54.3478261,7.49130853 C54.3478261,14.4927536 68.8405797,14.6388713 68.8405797,20.6586821 C68.8405797,26.6784929 67.4575975,28.7097202 61.5942029,28.7097202 C55.7308083,28.7097202 54.8216732,25.4673485 54.8216732,21.9840622"
                    id="Path-10"
                  />
                  <g id="Group" transform="translate(78.260870, 0.000000)">
                    <path
                      d="M1.0658141e-14,0.371609067 L14.1229615,0.371609067"
                      id="Path-11"
                    />
                    <path
                      d="M7.06148076,0.371609067 L7.06148076,28.3661918"
                      id="Path-12"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

class Mail extends React.Component {
  render() {
    let { color = "#F5812E" } = this.props;
    return (
      <svg
        width="250px"
        height="250px"
        viewBox="0 0 300 300"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink"
      >
        <title>Group 8</title>
        <desc>Created with Sketch.</desc>
        <g
          id="Guideline"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="Illustrations" transform="translate(-405.000000, -219.000000)">
            <g id="Group-8" transform="translate(405.000000, 219.000000)">
              <circle id="Oval" fill={color} cx="150" cy="150" r="150" />
              <g
                id="Group-7"
                transform="translate(150.500000, 150.500000) rotate(-14.000000) translate(-150.500000, -150.500000) translate(35.000000, 108.000000)"
                stroke="#FFFFFF"
                stroke-width="7"
              >
                <rect
                  id="Rectangle"
                  x="105.5"
                  y="3.5"
                  width="122"
                  height="78"
                  rx="15"
                />
                <path
                  d="M20.6001882,42.5 L80.2999373,42.5"
                  id="Path-13"
                  stroke-linecap="round"
                />
                <path
                  d="M44.7000627,20.5 L79.8998118,20.5"
                  id="Path-13-Copy"
                  stroke-linecap="round"
                />
                <path
                  d="M0.900125435,64.5 L80.6997491,64.5"
                  id="Path-13-Copy-2"
                  stroke-linecap="round"
                />
                <path
                  d="M107,6 C141.555743,29.7519506 161.367367,41.7507191 166.43487,41.9963057 C171.502373,42.2418922 191.357417,30.2431237 226,6"
                  id="Path-14"
                  stroke-linejoin="round"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

export { Hi, Lock, Mail };
